// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandAppIconScreen_block_1jrs1","card":"BrandAppIconScreen_card_21KC8"};